import * as React from 'react';
import * as S from './styles';
import MonitorIcon from 'common/icons/monitorIcon';
import CellphoneIcon from 'common/icons/cellphoneIcon';
import { CSSProperties } from 'styled-components';
import Tabs, { TabItem } from 'components/Tabs';
import { IProps } from './types';
import { Provider, ProviderRating, WidgetPageType } from '../state/types';
import { WidgetPage } from '../state/types';
import DesktopPreview from './DesktopPreview';
import MovilPreview from './MovilPreview';
import { shallowEqual, useSelector } from 'react-redux';
import { RootState } from 'store/types';
import { createRGBA } from '../state/utils';
import { cloneDeep } from 'lodash';

const Preview: React.FC<IProps> = (props) => {
    const [viewType, setViewType] = React.useState<string> ("DESKTOP");
    const rootProps = useSelector((rootState: RootState) => {
        return {
            selectedDealer: rootState.dealers.dealer.selectedDealer,
        }
    }, shallowEqual);

    const {
        widgetsCalls,
        widgetsConfig,
        providersRating,
    } = useSelector((rootState: RootState) => {
        return {
            widgetsCalls: rootState.reviews.widgetsCalls,
            widgetsConfig: rootState.reviews.widgets,
            providersRating: rootState.reviews.providersRating
        }
    }, shallowEqual);

    function checkEntireConfig(widgetCall: string|undefined) {
        let newWidgetCall = cloneDeep(widgetCall);
        if (newWidgetCall && rootProps.selectedDealer && props.selectedTab === "entire" && newWidgetCall!.indexOf("ENT") === -1) {
            newWidgetCall = newWidgetCall?.replaceAll(rootProps.selectedDealer.id + ".js","ENT" + rootProps.selectedDealer.id + ".js");            
        }
        return newWidgetCall;
    }
    
    const widgetCalls: (string|undefined)[] = getWidgetCalls();
    
    function getWidgetCalls(): (string|undefined)[]{
        let arrayCalls :(string|undefined)[] = [];
        arrayCalls.push(checkEntireConfig(widgetsCalls?.overallRatingCall));
         
        let configPage: WidgetPage;
        if (props.selectedTab == "entire" && widgetsConfig) {
            configPage = widgetsConfig.entireConfig;
        }
        else if (props.selectedTab != "entire" && widgetsConfig) {
            configPage = widgetsConfig.individualConfig;
        }        


        if (providersRating && providersRating.providersRating)
        {             
            let totalReviews =0;
            providersRating.providersRating.map((providerRating:ProviderRating)=>{

                let providerSelected = configPage!.providersRating.providers.find((provider:Provider)=>{return provider.name.toLocaleLowerCase()== providerRating.provider.toLocaleLowerCase()})
                if (providerSelected)
                    totalReviews+= providerRating.totalReviews;
            })            
            if (totalReviews>0)
                arrayCalls.push(checkEntireConfig(widgetsCalls?.providersRatingCall));
            else
                arrayCalls.push(undefined);
        }
        

        arrayCalls.push(checkEntireConfig(widgetsCalls?.topReviewsCall));
        arrayCalls.push(checkEntireConfig(widgetsCalls?.leaveReviewCall));
        arrayCalls.push(checkEntireConfig(widgetsCalls?.reviewListCall));

        return arrayCalls;
    }


    function getFinalColor(color: string|undefined, opacity: number|undefined): string {
        if (!color || color === "") {
            color = "#ffffff";
        }
        if (opacity === undefined) {
            opacity = 100;
        }
        return createRGBA(color, opacity);
    }

    function getBackgroundColors(): string[] {
        let bgColors: string[] = [];
        if (widgetsConfig) {
            let configPage: WidgetPage;
            if (props.selectedTab == "entire" && widgetsConfig) {
                configPage = widgetsConfig.entireConfig;
            }
            else if (props.selectedTab != "entire" && widgetsConfig) {
                configPage = widgetsConfig.individualConfig;
            }
            bgColors.push(getFinalColor(configPage!.overallRating.backgroundColor, configPage!.overallRating.backgroundOpacity));
            bgColors.push(getFinalColor(configPage!.providersRating.backgroundColor, configPage!.providersRating.backgroundOpacity));
            bgColors.push(getFinalColor(configPage!.topReviews.backgroundColor, configPage!.topReviews.backgroundOpacity));
            bgColors.push(getFinalColor(configPage!.leaveReview.backgroundColor, configPage!.leaveReview.backgroundOpacity));
            bgColors.push(getFinalColor(configPage!.reviewList.backgroundColor, configPage!.reviewList.backgroundOpacity));
        }
        return bgColors;
    }

    const backgroundColors: string[] = getBackgroundColors(); 

    const handleViewTypeSelection = (selectedViewType: string) => {   
        setViewType(selectedViewType);
    }

    return (
        <S.MainContainer>
            <S.IconsContainer>
                <S.IconContainer onClick={() => handleViewTypeSelection("MOVIL")}>
                    <CellphoneIcon strokeColor={viewType==="MOVIL" ? "#112240" : "#A5A5A5"}/>
                </S.IconContainer>
                <S.IconContainer onClick={() => handleViewTypeSelection("DESKTOP")}>
                    <MonitorIcon strokeColor={viewType==="DESKTOP" ? "#112240" : "#A5A5A5"}/>
                </S.IconContainer>
            </S.IconsContainer>
            {
                viewType === "DESKTOP" &&
                <DesktopPreview widgetCalls={widgetCalls} backgroundColors={backgroundColors} viewType={viewType} selectedTab={props.selectedTab}/>
            }
            {
                viewType === "MOVIL" &&
                <MovilPreview widgetCalls={widgetCalls} backgroundColors={backgroundColors} viewType={viewType} selectedTab={props.selectedTab}/>
            }
        </S.MainContainer>
    )
}

export default Preview;
